/**
 * Persisted animation preference — the ONLY reduction path in the game.
 *
 * Policy (user decision, playtest round 2, 2026-08-02): the game shows
 * FULL animations to everyone by default and deliberately IGNORES the
 * OS prefers-reduced-motion setting. Rationale: the combat-juice layer
 * is the game's legibility system ("what happened?"), and iOS Reduce
 * Motion is commonly enabled for scroll-parallax comfort — friends with
 * it on were silently losing the entire combat experience with no
 * recourse. The in-app "Reduce animations" toggle in Settings is the
 * accessibility valve; it collapses the same set of behaviors the old
 * media-query path did.
 *
 * Same storage posture as controlMode: failures are silent (value
 * stays in-memory for the session), NOT part of the save schema.
 */

const STORAGE_KEY = 'poke-reduce-animations';

let inMemory: boolean | null = null;

export function getReduceAnimations(): boolean {
  if (inMemory !== null) return inMemory;
  try {
    inMemory = localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    inMemory = false;
  }
  return inMemory;
}

export function setReduceAnimations(value: boolean): void {
  inMemory = value;
  try {
    localStorage.setItem(STORAGE_KEY, value ? '1' : '0');
  } catch {
    // Silent — in-memory only this session, same as controlMode.
  }
}

/** Test helper — reset the in-memory cache so storage mocks take effect. */
export function __resetMotionPrefsForTest(): void {
  inMemory = null;
}
